import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectAuthData, selectEnergyAuthCommonData } from '@/containers/Login/AuthSelectors'
import {
  selectActiveAddress,
  selectAddressesConfigData,
  selectCurrentAddressData,
  selectCurrentAddressErrors,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  updateAddressData,
  updateAddressesConfigData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useModal from '@/shared/hooks/v2/useModal'
import { BUILDING_PERMIT_OPTION_OBTAINED } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

const useBuildingPermit = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { country } = useSelector(selectAuthData)
  const { isEditable, errors: contractErrors } = useFormStatus()
  const activeAddress = useSelector(selectActiveAddress)
  const { buildingPermitData = {} } = useSelector(selectCurrentAddressData)
  const {
    building_permit_option: buildingPermitOption,
    building_permit_number: buildingPermitNumber,
    building_permit_date: buildingPermitDate,
    building_permit_entity: buildingPermitEntity,
    building_permit_city: buildingPermitCity,
  } = buildingPermitData as any
  const addressErrors = useSelector(selectCurrentAddressErrors)
  const errors = { ...addressErrors, ...contractErrors }
  const { buildingPermitOptions: buildingPermitOptionsRaw = {} } = useSelector(selectEnergyAuthCommonData) ?? {}
  const buildingPermitOptions = Object.keys(buildingPermitOptionsRaw)
  const { isOpen, openModal, closeModal } = useModal({
    selector: selectAddressesConfigData,
    actionCreator: updateAddressesConfigData,
    modalKey: 'buildingPermitModal',
  })
  // @ts-ignore
  const addressConfig = modulesConfig[country]?.address ?? {}
  const hidden = !addressConfig.buildingPermit
  const hideBuildingPermitFields = buildingPermitOption !== BUILDING_PERMIT_OPTION_OBTAINED
  const isFilled =
    Boolean(buildingPermitOption) &&
    (hideBuildingPermitFields ||
      (Boolean(buildingPermitNumber) &&
        Boolean(buildingPermitDate) &&
        Boolean(buildingPermitEntity) &&
        Boolean(buildingPermitCity)))

  const updateAddress = (data: object) => {
    // @ts-ignore
    dispatch(updateAddressData({ data: { buildingPermitData: { ...buildingPermitData, ...data } }, id: activeAddress }))
  }

  return {
    t,
    errors,
    isEditable,
    buildingPermitOption: buildingPermitOption ?? '',
    buildingPermitNumber,
    buildingPermitDate: buildingPermitDate ? new Date(buildingPermitDate) : '',
    buildingPermitEntity,
    buildingPermitCity,
    buildingPermitOptions,
    hidden,
    hideBuildingPermitFields,
    isFilled,
    isOpen,
    openModal,
    closeModal,
    updateAddress,
  }
}

export default useBuildingPermit
